import React from "react";
import {
  Tabs,
  Row,
  Col, 
  Form,
  Input,
  Button,
  Select,
 
} from "antd";
import { message } from "antd";
import SubmitButton from '../Patient/SubmitButton'
import {  currentPrescriptionTab ,switchPrescriptionTabs} from "store/slice/tabs-slice";
import { setPublishClicked } from "store/slice/videoConsultation-slice";
import { connect } from "react-redux";
import api from "utils/api";
import utils from "utils";
import "./VideoConsultation.scss";
import "./PrescriptionTab.scss";
const { TextArea } = Input;
const { TabPane } = Tabs;
import { ArrowRightOutlined } from '@ant-design/icons'
import Loader from "Components/Loader";
import { CONSTANTS } from "utils/constant";
import Validators from "Common/Validators";
let temp_data_prescription = [];

 class DietTab extends React.Component {
  form = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
        isloading:true,
      temp_diet: [],
      disable_type: false,
      submit_diet: false,
      throw_err: false,
      prescriptionValue: this.props.prescriptionValue,
      diet_btn_text: "Submit",
      is_prescription: false,
      is_submit: false,
      is_prescription_done: false,
      is_edit: false,
      form_action:false,
      visible_publish:true,
      buttonLoading: true
    };
    this.form = React.createRef();
    //this.updateInfo = this.updateInfo.bind(this);
    //this.switchPrescriptionTabs=this.switchPrescriptionTabs.bind(this)
  }

 
 
  handleSubmit(value) {
      this.setState({ wellness_goal: value?.["wellness_goal"]?.trim() || "", buttonLoading: true });
      ["dosage", "drug_name", "form", "frequency", "instruction", "duration", "wellness_goal", "type"].forEach(e => delete value[e]);
      Object.entries(value).forEach(([key, val]) => {
        if (val["favored"] == undefined && val["avoided"] == undefined && val["advice"] == undefined) val["is_diet"] = false;
        else { val["is_diet"] = true; this.setState({ submit_diet: true }) }
        if (val["favored"] == undefined) val["favored"] = [];
        if (val["avoided"] == undefined) val["avoided"] = []
        if (val["advice"] == undefined) val["advice"] = ""
        val["diet_type"] = key
      })
      // console.log(value)
      const arr2 = new Array(4);
      let formData = {}
      for (let i = 0; i < arr2.length; i++) {
        let temp = Object.values(value)
        if (temp?.[i]?.["is_diet"] == true || this.state.wellness_goal.length > 0) this.setState({ submit_diet: true })
        arr2[i] = temp[i] || "";        
        formData = {
          is_completed: true,
          prescription_mail: false,
          appointment_id: this.props.appointment_id,
          data: {
            diet_plan: arr2,
            wellness_goal: this.state.wellness_goal
          },
          type:"diet",
          is_prescription_required : true,
        }
        // this.setState({ formData: formData })
      }
      if(!this.state.submit_diet){
        typeof this.props?.formAction == "function" && this.props.formAction(false)
        message.error(`${CONSTANTS.ALLOPATHY_CANNOT_SUBMIT}`, ErrorDuration)
        this.setState({buttonLoading: false})
       }
      else{
      api.submit_prescription(formData).then(res => {
        if (res.data?.status == 200) {
          this.props.setPublishClicked({[this.props.appointment_id] : true});
          typeof this.props?.formAction == "function" && this.props.formAction(false);
          typeof this.props?.visiblePublish == "function" && this.props.visiblePublish()
          typeof this.props.handleFunction == "function" && this.props.handleFunction({ is_prescription: true });
          message.success(res.data?.message, ErrorDuration,);
          this.setState({ diet_btn_text: "Update",isloading:false, buttonLoading: false });
          if (this.props?.prescription_enable){ this.props.disablePrescription(true)}
        }
      })
    }
//this.props.handleSubmit(this.state.is_submit,"diet",this.state.formData)
      // {
      //   !this.state.submit_diet ? message.error("Cannot submit empty  Prescription!.", ErrorDuration) :
      //     api.submit_prescription(this.state.formData).then(res => {
      //       // console.log(res)
      //       if (res.data?.status == 200) {
      //         typeof this.props?.visiblePublish == "function" && this.props.visiblePublish()
      //         typeof this.props.handleFunction == "function" && this.props.handleFunction({ is_prescription: true });
      //         message.success(res.data?.message, ErrorDuration);
      //         this.setState({ diet_btn_text: "Update" })
      //         this.switchPrescriptionTabs("remove", this.state.selectedTab)
      //         if (this.props.disablePrescription) this.props.disablePrescription(true)
      //       }
      //     })
      // }
    

  }



  
  getDefaultPrescripitons(){
    this.setState({buttonLoading: true, diet_btn_text: "Submit"})
  api.get_prescription("diet").then(res => {
    this.setState({ data: res.data.data.results[0], isloading: false, update_info: false, buttonLoading: false })
      let { diet_plan: diet_data } = this.state.data;
      this.setState({ diet_data: diet_data, isloading:false})
  })
  let data = {
    app_id: this.props.appointment_id,
    type: "prescription"
  }
  api.get_consultation_details(data)
  .then((response) => {
    if (response.data.data?.results?.prescription.length > 0)
    // typeof this.props?.visiblePublish == "function" && this.props.visiblePublish()
  this.setState({ response: response.data.data?.results?.prescription[0],visible_publish: response.data.data?.results?.prescription[0]?.is_prescription_report ? false :true,})
    if (this.state.response?.is_diet) this.setState({ temp_diet: this.state.response?.diet_plan?.diet_plan ,diet_btn_text:"Update"})
    for (let i = 0; i < this.state.temp_diet.length; i++) {
      let { diet_type: temp_diet } = this.state.temp_diet[i]
      this.state.temp_diet[temp_diet] = this.state.temp_diet[i]
      this.form.current && this.form.current.setFieldsValue(this.state.temp_diet)
      this.form.current && this.form.current.setFieldsValue({ wellness_goal: this.state.response?.diet_plan?.wellness_goal || "" })
    }
  })
  
  }



  componentDidMount() {
    this.getDefaultPrescripitons()
    typeof this.props.formAction == "function" && this.props.formAction(false)
  };
 
  
  render() {
    return (
      <>
      
      <>
        <Row gutter={24}>
          <Col span={24}>
            <div className="prescription-tab" >
              <Form
                name="addPrescription"
                ref={this.form}
                onFinish={this.handleSubmit.bind(this)}
                //onValuesChange={(aa,bb)=> console.log(aa,bb)}
                onFieldsChange={(value) =>{typeof this.props.formAction == "function" && this.props.formAction(true)}}
                labelAlign={"left"}
                 labelWrap
                colon={false}
                scrollToFirstError={{
                  behavior: 'smooth',
                  block: 'center',
                  inline: 'center',
                }}
              >
                           
<div>
                          <Col span={{xs:24, md:24, lg:24, xl: 16, xxl:16}} >
                            <Form.Item 
                              style={{ marginLeft:"auto", marginRight:"auto",}}
                              name={["wellness_goal"]}
                              label={<p>{CONSTANTS.WELLNESS_GOAL}</p>}
                              labelCol={{xs:12, md:11, lg:8, xl:7, xxl:5}}
                              wrapperCol={{ xs:12, md:13, lg:16, xl:17 ,xxl:19 }}

                            >
                              <Input.TextArea  disabled={this.props.prescriptionValue === 1 ? true : false} />
                            </Form.Item>
                          </Col>


                          <div className="plan-block" >
                            {Object.values(this.state?.data?.diet_plan || {}).map((y) => {
                              let { diet_type: label } = y || {}
                              return (
                                <Col span={24}>
                                  <div className="diet-plan">
                                    <Form.Item className="header-label"
                                      name={[label, `is_${label}`]}
                                      label={<p style={{textDecoration:"underline"}}>{utils.Capitalize(label)}</p>}
                                      colon={false}
                                    >
                                    </Form.Item>
                                    <>

                                      <Col span={24}>
                                        <Form.Item
                                          name={[label, 'favored']}
                                          labelCol={{xs:12, md:11, lg:8, xl:7, xxl:5}}
                                          wrapperCol={{ xs:12, md:13, lg:16, xl:17 ,xxl:19 }}
                                          label={CONSTANTS.TO_BE_FAVOURED}
                                          rules={[
                                            Validators.validateIsDietTab
                                          ]}
                                        >
                                          <Select
                                            disabled={this.props.prescriptionValue === 1 ? true : false}
                                            mode="tags"
                                            open={false}
                                            //onClick={()=>{this.switchPrescriptionTabs("add","diet")}} 
                                          />
                                        </Form.Item>
                                      </Col>
                                      <Col span={24}>
                                        <Form.Item
                                          name={[label, 'avoided']}
                                          labelCol={{xs:12, md:11, lg:8, xl:7, xxl:5}}
                                          wrapperCol={{ xs:12, md:13, lg:16, xl:17 ,xxl:19 }}
                                          label={CONSTANTS.TO_BE_AVOIDED}
                                          rules={[
                                            Validators.validateIsDietTab
                                          ]}
                                        >
                                          <Select
                                            disabled={this.props.prescriptionValue === 1 ? true : false}
                                            mode="tags"
                                            open={false}
                                            //onClick={() => { this.switchPrescriptionTabs("add", "diet") }} 
                                          />
                                        </Form.Item>
                                      </Col>
                                      <Col span={24}>
                                        <Form.Item
                                          name={[label, "advice"]}
                                          labelCol={{xs:12, md:11, lg:8, xl:7, xxl:5}}
                                          wrapperCol={{ xs:12, md:13, lg:16, xl:17 ,xxl:19 }}
                                          label={CONSTANTS.DIET_ADVISED}
                                        //onClick={(e) => (console.log(e, e.target.value, e.code, e.keyCode))}
                                        >
                                          <Input onPressEnter={(e) => e.preventDefault()} disabled={this.props.prescriptionValue === 1 ? true : false} />
                                        </Form.Item>
                                      </Col>
                                    </>
                                  </div>
                                </Col>
                              )
                            })}
                          </div>
                          {(this.state.visible_publish && (this.props?.visible_publish == false ? false : true) && !this.props?.is_prescription_report)?
                          <div className="submit-button-wrapper">
                            <SubmitButton label={this.state.diet_btn_text} className={"common-btn"} disabled={this.props.prescriptionValue === 1 ? true : false} onClick={e => {this.setState({is_submit:true}),this.props?.from=="drawer_prescription"?this.setState({isloading:false}):null,this.form.current?.submit(e),this.props?.from=="drawer_prescription"?this.setState({isloading:false}):null}} loading={this.state.buttonLoading}/>
                            {/* <Button className="common-btn" disabled={this.props.prescriptionValue === 1 ? true : false} onClick={e => {this.setState({is_submit:true}),this.props?.from=="drawer_prescription"?this.setState({isloading:false}):null,this.form.current?.submit(e),this.props?.from=="drawer_prescription"?this.setState({isloading:false}):null}}>{this.state.diet_btn_text} <ArrowRightOutlined /></Button> */}
                          </div>:null}
                          </div>
                        
        
                </Form>
            </div>
          </Col>
        </Row>
        </>
      </>
    )
  }
}
const mapStateToProps = state => {
 
  return {

    allow_switchTab: state.tabsReducer.switch_tab,
    switch_prescription_tabs: state.tabsReducer.switch_prescription_tabs
  }
}
const mapDispatchToProps = {

  switchPrescriptionTabs,
  currentPrescriptionTab,
  setPublishClicked
}

export default connect(mapStateToProps, mapDispatchToProps)(DietTab); 